function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#95A1B2;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M17.89,16.83,1.17.11a.375.375,0,0,0-.53,0L.11.64a.375.375,0,0,0,0,.53l3.1,3.1A9.638,9.638,0,0,0,.018,8.886a.377.377,0,0,0,0,.229A9.451,9.451,0,0,0,9,15.75a9.268,9.268,0,0,0,4.519-1.17l3.31,3.31a.375.375,0,0,0,.53,0l.53-.53A.375.375,0,0,0,17.89,16.83ZM9,14.25A5.243,5.243,0,0,1,4.8,5.86l1.63,1.63A2.938,2.938,0,0,0,6,9a3,3,0,0,0,3,3,2.939,2.939,0,0,0,1.509-.43l1.63,1.63A5.238,5.238,0,0,1,9,14.25Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M246.2,170.98a.375.375,0,0,0,.081.411l2.593,2.593a.375.375,0,0,0,.64-.27,2.979,2.979,0,0,0-2.963-2.963A.409.409,0,0,0,246.2,170.98Z",
  transform: "translate(-237.513 -164.747)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M156.494,65.942a.375.375,0,0,0,.427.073,5.194,5.194,0,0,1,2.258-.517,5.256,5.256,0,0,1,5.25,5.25,5.194,5.194,0,0,1-.517,2.258.375.375,0,0,0,.073.427l1.3,1.3a.375.375,0,0,0,.265.11h0a.377.377,0,0,0,.266-.111,9.773,9.773,0,0,0,2.344-3.869.377.377,0,0,0,0-.229A9.451,9.451,0,0,0,159.179,64a9.339,9.339,0,0,0-3.284.595.375.375,0,0,0-.134.616Z",
  transform: "translate(-150.179 -61.749)"
})));

var SvgPasswordEyeClosed = function SvgPasswordEyeClosed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPasswordEyeClosed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/password-eye-closed.5bd2cfb3.svg";
export { ForwardRef as ReactComponent };